module.exports = {
    visualization: "Visualisierung",
    analytics: "Analytik",
    profile: "Profil",
    dashboard: "Wand",
    realtime: "In Echtzeit",
    voltage: "Spannung",
    current: "Strom",
    active_power: "Wirkleistung",
    reactive_power: "Blindleistung",
    apparent_power: "Scheinleistung",
    energy_export: "Energieversorgung",
    energy_import: "Energieverbrauch",
    hourly_active_report: "Stündlicher Bericht über die Wirkenergie",
    daily_active_report: "Täglicher Bericht über die aktive Energie",
    monthly_active_report: "Monatsbericht der aktiven Energie",
    daily_reactive_report: "Täglicher Blindleistungsbericht",
    language_change: "Lage",
    disaggregation: "Disaggregation",
    appliances_imprints: "Gerätefingerabdrücke",
    appliances_energy: "Verbrauch von Geräten",
    appliances_timeline: "Geräte-Timeline",
    appliances_run_profile: "Geräte im Leistungsprofil",
    imprints_map: "Appliance-Fingerabdruckkarte",
    logout: "Abmelden",
    logout_mini: "A",
    edit_profile: "Profil bearbeiten",
    edit_profile_mini: "PB",
    monitoring: "Überwachung",
    tools: "Werkzeuge",
    manual_learning: "Manuell lernen",
    settings: "Einstellungen",
    disconnector_timeline: "Zeitleiste",
    energy_profile: "Energieprofil",
    power_factor: "Leistungsfaktor",
    test_profile: "Testprofil",
    quarter_hour_active_report: "15 Minuten aktiver Bericht",
    testing_process: "Testprozess",
    tests_results: "Testergebnisse",
    integration: "Integration",
    quarter_hour_maximum_active_report: "Maximal in 15 Minuten",
    reactive_energy: "Blindleistung",
    state: "Zustand",
    rising_shapes: "Steigende Formen",
    falling_shapes: "Fallende Formen",
    firmware_upgrade: "Firmware-Aktualisierung",
    control_map: "Kontrollkarte",
    notifications: "Benachrichtigungen",
    anomaly_models: "Anomaliemodelle"
  }